export function setupViteHmr(store) {
    try {
        if ((import.meta as any).hot) {
            // Enable Webpack hot module replacement for reducers
            (import.meta as any).hot.accept("../reducers", () => {
                // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
                const nextReducer = require("../reducers").default;
                store.replaceReducer(nextReducer);
            });
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("Error while setting up Vite HMR", e);
    }
}
